import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { FormatQuote } from '@mui/icons-material';
import { brandColors } from '../../theme';

interface TestimonialProps {
  quote?: string;
  title?: string;
  organization?: string;
}

export const Testimonial: React.FC<TestimonialProps> = ({
  quote = "MarketCompass reports have become an essential tool for our investment decisions. The depth of analysis is unmatched in the industry.",
  title = "Senior Vice President",
  organization = "Global Hotel Group",
}) => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: brandColors.lightGray,
      }}
    >
      <Container maxWidth="md">
        <Paper
          sx={{
            position: 'relative',
            p: { xs: 4, sm: 6, md: 8 },
            borderRadius: 3,
            backgroundColor: brandColors.white,
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            textAlign: 'center',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: `linear-gradient(90deg, ${brandColors.gold} 0%, ${brandColors.blue} 100%)`,
            },
          }}
        >
          <FormatQuote
            sx={{
              fontSize: 64,
              color: brandColors.gold,
              opacity: 0.2,
              position: 'absolute',
              top: 20,
              left: 20,
              transform: 'rotate(180deg)',
            }}
          />
          
          <Typography
            variant="h5"
            sx={{
              color: brandColors.indigo,
              fontWeight: 400,
              fontStyle: 'italic',
              lineHeight: 1.8,
              mb: 4,
              px: { xs: 2, sm: 4 },
              position: 'relative',
              zIndex: 1,
            }}
          >
            "{quote}"
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: 60,
                height: 2,
                backgroundColor: brandColors.gold,
                mb: 2,
              }}
            />
            
            <Typography
              variant="subtitle1"
              sx={{
                color: brandColors.indigo,
                fontWeight: 600,
                fontSize: '1.125rem',
              }}
            >
              {title}
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                color: brandColors.mediumGray,
              }}
            >
              {organization}
            </Typography>
          </Box>
          
          <FormatQuote
            sx={{
              fontSize: 64,
              color: brandColors.gold,
              opacity: 0.2,
              position: 'absolute',
              bottom: 20,
              right: 20,
            }}
          />
        </Paper>
      </Container>
    </Box>
  );
};